import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

import { ref } from "vue";
import AppButton from "../ui-kit/button/AppButton.vue";
import AppIcon from "../ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "../ui-kit/dropdown/AppResizableDropdown.vue";
import { useBreakpoints } from "@/composables/useBreakpoints";

type DropdownProps = {
  position?: "left" | "right";
  label?: string;
  disabled?: boolean;
  width?: string;
  type: string;
};

type DropdownEmits = {
  "on-close": [];
  select: [option: string];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FileDropdown',
  props: {
    position: { default: "right" },
    label: { default: "Menu" },
    disabled: { type: Boolean, default: false },
    width: { default: "" },
    type: { default: "default" }
  },
  emits: ["on-close", "select"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;
const { isMobile } = useBreakpoints();

const dropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null);
const isOpen = ref(false);

const closeDropdown = () => {
  dropdownRef.value?.close();
};

const blurActiveEditorOnMobile = () => {
  if (!isMobile.value) return;

  const activeElement = document.activeElement;
  if (
    activeElement instanceof HTMLElement &&
    activeElement.matches('input, textarea, [contenteditable="true"]')
  ) {
    activeElement.blur();
  }
};

const handleClose = () => {
  isOpen.value = false;
  emit("on-close");
};

const handleSelect = (option: string) => {
  closeDropdown();
  emit("select", option);
};

__expose({ closeDropdown });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppResizableDropdown, {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: "app-dropdown",
    position: _ctx.position,
    trigger: _unref(isMobile) ? 'click' : _ctx.type === 'menu' ? 'hover' : 'click',
    "hover-delay": 300,
    "hover-close-delay": 1000,
    resizable: false,
    "close-by-click-outside": true,
    "mobile-title": _ctx.$t('contact_choose_action'),
    onOpen: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
    onClose: handleClose
  }, {
    activator: _withCtx(() => [
      (_ctx.type === 'default')
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            label: _ctx.label,
            disabled: _ctx.disabled,
            active: isOpen.value,
            width: _ctx.width,
            type: "dropdown"
          }, null, 8, ["label", "disabled", "active", "width"]))
        : (_openBlock(), _createBlock(AppIcon, {
            key: 1,
            name: "options-menu",
            width: "16px",
            color: "#979797",
            cursor: "pointer",
            "hover-color": "#499259",
            onPointerdown: blurActiveEditorOnMobile
          }))
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", { onSelect: handleSelect })
    ]),
    _: 3
  }, 8, ["position", "trigger", "mobile-title"]))
}
}

})